import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import { MENU_BAR_HEIGHT } from 'containers/Dashboard/components/AppBar/styles';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: ${({ isMobile }) => MENU_BAR_HEIGHT(isMobile)};
`;

export const ContentWrap = styled.article`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;

export const SectionWrap = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  padding: ${({ padding }) => (padding || '1rem 2rem')};
  max-width: ${({ maxWidth }) => (maxWidth || '1280px')};
  min-width: ${({ minWidth }) => (minWidth || '0')};
  max-height: ${({ maxHeight }) => (maxHeight || '100%')};
  min-height: ${({ minHeight }) => (minHeight || '0')};
  overflow: ${({ overflow }) => overflow || 'auto'};

  > h3 {
    margin-bottom: 1rem;
  }
`;

export const SectionFlex = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  overflow: ${({ overflow }) => (overflow || 'hidden')};
  max-width: ${({ maxWidth }) => (maxWidth || '100%')};
  min-width: ${({ minWidth }) => (minWidth || '0')};
  max-height: ${({ maxHeight }) => (maxHeight || '100%')};
  min-height: ${({ minHeight }) => (minHeight || '0')};
  flex: ${({ flex }) => (flex || 'unset')};
`;

export const HeadRow = styled(Grid)`
  margin-bottom: 1rem;
`;

export const TitleWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 2.6875rem;
  h3 {
    margin-right: 1rem;
    white-space: nowrap;
  }
`;
